import { folder, id } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrievePrivateDocumentsRequestFailure(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.request.isFailure : false;
    },
    isRetrievePrivateDocumentsRequestPending(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.request.isPending : false;
    },
    isRetrievePrivateDocumentsRequestSuccess(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.request.isSuccessful : false;
    },
    getPrivateDocuments(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.folder : { ...folder, uuid: id };
    },
  };
}

export { createSelector };
